module.exports = __webpack_public_path__ + "img/cover6.0f54682e.jpeg";